import TripMatchDetailsContainer from './trip-match-details-container';

export default TripMatchDetailsContainer;
